import React from 'react'
import { Private } from '@ally/private'
import { AccountDetails } from '../../../types'
import { AcctDetailsItem, Dd, Dt } from './StyledDlElements'

interface AccountOwnersDlProps {
  account: AccountDetails
}

// istanbul ignore file // TO DO METRONOME UPGRADE REMOVE IGNORE AFTER WE FIX TESTS FAILING

export const AccountOwnersDl: React.FC<AccountOwnersDlProps> = ({
  account,
}) => {
  return (
    <AcctDetailsItem>
      <Dt>Account Owners:</Dt>
      <Dd>
        {account.ownerNames.map((accountOwner: string) => (
          <Private key={accountOwner}>
            <div>{accountOwner}</div>
          </Private>
        ))}
      </Dd>
    </AcctDetailsItem>
  )
}
